import axios from 'axios'
import objectToFormData from '@/src/utils/object-to-form-data'

const resource = 'users'

class UserService {
  constructor() {
    this.url = `/api/v1/${resource}`
  }

  /**
   * Sends a put request to the backend to update
   * the resource by a certain id
   * @param {Number} id
   * @param {Object} data
   * @returns {Promise} Promise object with data from axios put call
   */
  update(id, data) {
    return axios.put(`${this.url}/${id}`, data)
  }

  getUser(id) {
    return axios.get(`${this.url}/${id}`)
  }

  /**
   * Sends a post request to the backend to register new user
   * @param {Object} data The data entered in the registration form
   * @returns {Promise} Promise object represents axios post call
   */
  register(data) {
    return axios.post(`${this.url}/register/`, data)
  }

  /**
   * Sends a post request to the backend to upload an image
   * for the user's avatar
   * @param {Object} data
   * @returns {Promise} Promise object represents axios post call
   */
  uploadImage(data) {
    return axios.post(`${this.url}/avatar/`, objectToFormData(data), {
      'Content-Type': 'multipart/form-data',
    })
  }

  /**
   * Sends a delete request to the backend to delete an image
   * from user's avatar
   * @returns {Promise} Promise object represents axios delete call
   */
  deleteImage() {
    return axios.delete(`${this.url}/avatar/`)
  }

  /**
   * Sends a get request to the backend to receive
   * the user's options
   * @returns
   */
  options() {
    return axios.get(`${this.url}/options/`)
  }
}

export const userService = new UserService()
